/*
 * Public API Surface of ngx-extended-pdf-viewer
 */

export * from './lib/ngx-extended-pdf-viewer.component';
export * from './lib/ngx-extended-pdf-viewer.module';
